import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  SimpleChanges
} from "@angular/core";
import { SlotDataService } from "../slots-data.service"; 
import { FormBuilder, FormGroup } from "@angular/forms";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "../../shared/services/shared.service";

@Component({
  selector: "app-choose-slot",
  templateUrl: "./choose-slot.component.html",
  styleUrls: ["./choose-slot.component.css"]
})
export class ChooseSlotComponent implements OnInit, OnDestroy {
  @Input() appointmentDetail;
  @Input() page;
  @Output() onNextSlot = new EventEmitter();
  @Output() onPrevSlot = new EventEmitter();
  disableNextPage : boolean = false;
  public chosendate = "";
  public chosentime = "";
  public locale;
  isRecruiter : boolean = false;
  public languageSubscription;
  selectedDayData = {'morningData' : [],'afternoonData':[],'eveningData':[],'nightData':[]};
  monthData;
  selectedDate;
  confirmTime;
  confirmDate;
  count = 0;
  previousDateSelected = {'slot':'','index' : 0,'date':''};
  //dubPreviousDateSelected = {};
  public isExternal;
  public externalStyle;
  public savedAppointmentSlot = {};

  public bookAppointmentForm: FormGroup;

  constructor(
    public slotDataService: SlotDataService,
    private activatedRoute : ActivatedRoute,
    private _fb: FormBuilder,
    private sharedService : SharedService
  ) {}

  ngOnInit() {
    this.activatedRoute.snapshot.queryParams.type == "1" ? this.isRecruiter = true : this.isRecruiter = false;
    this.createForm();
    this.isExternal = this.sharedService.isExternal;
    this.externalStyle = this.sharedService.externalStyle;
    if(this.externalStyle){
      this.externalStyle = JSON.parse(this.externalStyle);
    }
  }


  manageSlots(){
    if(this.appointmentDetail && this.appointmentDetail.BookingSlotsShiftwise) this.appointmentDetail.BookingSlotsShiftwise.forEach(element =>{
      if(element.IsSelectedCalendar){
        this.selectedDayData['morningData'] = element.MorningSlots;
        this.selectedDayData['afternoonData'] = element.AfternoonSlots;
        this.selectedDayData['eveningData'] = element.EveningSlots;
        this.selectedDayData['nightData'] = element.NightSlots;
        this.monthData = element.Date;       
      
        element.MorningSlots.forEach(data=>{
          if(data.IsSelected == true){
            this.bookAppointmentForm.value["bookingTime"] = data.StartTime;
            this.bookAppointmentForm.value["endTime"] = data.EndTime;
          }
        })
        element.AfternoonSlots.forEach(data=>{
          if(data.IsSelected == true){
            this.bookAppointmentForm.value["bookingTime"] = data.StartTime;
            this.bookAppointmentForm.value["endTime"] = data.EndTime;
          }
        })
        element.EveningSlots.forEach(data=>{
          if(data.IsSelected == true){
            this.bookAppointmentForm.value["bookingTime"] = data.StartTime;
            this.bookAppointmentForm.value["endTime"] = data.EndTime;
          }
        })
        element.NightSlots.forEach(data=>{
          if(data.IsSelected == true){
            this.bookAppointmentForm.value["bookingTime"] = data.StartTime;
            this.bookAppointmentForm.value["endTime"] = data.EndTime;
          }
        })
        this.bookAppointmentForm.value["bookingDate"] = element.Date;
      }else{
        this.count++;
      }
      
      if(this.count == this.appointmentDetail.BookingSlotsShiftwise.length){
        
        this.selectedDayData['morningData'] = this.appointmentDetail.BookingSlotsShiftwise[0].MorningSlots;
        this.selectedDayData['afternoonData'] = this.appointmentDetail.BookingSlotsShiftwise[0].AfternoonSlots;
        this.selectedDayData['eveningData'] = this.appointmentDetail.BookingSlotsShiftwise[0].EveningSlots;
        this.selectedDayData['nightData'] = this.appointmentDetail.BookingSlotsShiftwise[0].NightSlots;
        this.appointmentDetail.BookingSlotsShiftwise[0].IsSelectedCalendar = true;
        this.slotDataService.setBookAppointment({'bookingDate' : this.appointmentDetail.BookingSlotsShiftwise[0].Date});        
        this.monthData = this.appointmentDetail.BookingSlotsShiftwise[0].Date;
      }
      
      for (let morningI = 0; morningI < element.MorningSlots.length; morningI++) {
        const e = element.MorningSlots[morningI];
        if(e.IsSelected == true){
          this.previousDateSelected.slot = 'morningData';
          this.previousDateSelected.index = morningI;
          this.previousDateSelected.date= element.Date;
          this.savedAppointmentSlot[element.Date] = JSON.parse(JSON.stringify(e));
        }
      }

      for (let eveningI = 0; eveningI < element.EveningSlots.length; eveningI++) {
        const e = element.EveningSlots[eveningI];
        if(e.IsSelected == true){
          this.previousDateSelected.slot = 'eveningData';
          this.previousDateSelected.index = eveningI;
          this.previousDateSelected.date = element.Date;
          this.savedAppointmentSlot[element.Date] = JSON.parse(JSON.stringify(e));
        }
      }
      for (let noonI = 0; noonI < element.AfternoonSlots.length; noonI++) {
        const e = element.AfternoonSlots[noonI];
        if(e.IsSelected == true){
          this.previousDateSelected.slot = 'afternoonData';
          this.previousDateSelected.index = noonI;
          this.previousDateSelected.date = element.Date;
          this.savedAppointmentSlot[element.Date] = JSON.parse(JSON.stringify(e));
        }
      }
      for (let nightI = 0; nightI < element.NightSlots.length; nightI++) {
        const e = element.NightSlots[nightI];
        if(e.IsSelected == true){
          this.previousDateSelected.slot = 'nightData';
          this.previousDateSelected.index = nightI;
          this.previousDateSelected.date = element.Date;
          this.savedAppointmentSlot[element.Date] = JSON.parse(JSON.stringify(e));
        }
      }
      this.bookAppointmentForm.value["bookingDate"] = this.bookAppointmentForm.value["bookingDate"] || this.appointmentDetail.BookingSlotsShiftwise[0].Date;
      this.slotDataService.savedAppointmentSlot = JSON.parse(JSON.stringify(this.savedAppointmentSlot));
      this.slotDataService.setBookAppointment(this.bookAppointmentForm.value);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.appointmentDetail){
      this.previousDateSelected = {'slot':'','index' : 0,'date':''}
      this.count = 0;
      if(!changes.appointmentDetail.currentValue || !changes.appointmentDetail.currentValue.BookingSlotsShiftwise || 
          changes.appointmentDetail.currentValue.BookingSlotsShiftwise.length == 0){
        this.appointmentDetail = changes['appointmentDetail'].previousValue;
        //this.getSlots('prev');
        this.disableNextPage = true;
      }
      else if(changes.appointmentDetail.currentValue.BookingSlotsShiftwise.length < 5){
        this.appointmentDetail = changes['appointmentDetail'].currentValue;
        this.disableNextPage = true;
      }
      else{
      this.appointmentDetail = changes['appointmentDetail'].currentValue;
      this.disableNextPage = false;
      }
      this.manageSlots();
    }
  }

  getSlots(type) {
    this.bookAppointmentForm.removeControl('bookingTime');
    this.bookAppointmentForm.removeControl('endTime');
    if (type == "next") {
      this.onNextSlot.emit("next");
    } else {
      this.onPrevSlot.emit("prev");
    }
  }

  public createForm() {
    this.bookAppointmentForm = this._fb.group({});
  }

  selectedDay(items){
    let previousDate = "";
    
    /* Toggle active date selection */
    // ------------------------------------------
    this.appointmentDetail.BookingSlotsShiftwise.forEach(data=>{
      if(data.IsSelectedCalendar){
        data.IsSelectedCalendar = false;
      }
    })
    items.IsSelectedCalendar = true;
    // ------------------------------------------

    items.MorningSlots.forEach(data=>{
      if(data.IsSelected == true){
        data.IsSelected = false;
      }
    })
    items.AfternoonSlots.forEach(data=>{
      if(data.IsSelected == true){
        data.IsSelected = false;
      }
    })
    items.EveningSlots.forEach(data=>{
      if(data.IsSelected == true){
        data.IsSelected = false;
      }
    })
    items.NightSlots.forEach(data=>{
      if(data.IsSelected == true){
        data.IsSelected = false;
      }
    })
    if(items.Date == this.previousDateSelected['date']){
      
      if(this.previousDateSelected['slot'] == 'morningData'){
        items.MorningSlots[this.previousDateSelected['index']].IsSelected = true;
        previousDate = items.Date;
      }
      else if(this.previousDateSelected['slot'] == 'afternoonData'){
        items.AfternoonSlots[this.previousDateSelected['index']].IsSelected = true; 
        previousDate = items.Date;  
      }
      else if(this.previousDateSelected['slot'] == 'eveningData'){
        items.EveningSlots[this.previousDateSelected['index']].IsSelected = true; 
        previousDate = items.Date;  
      }
      else if(this.previousDateSelected['slot'] == 'nightData'){
        items.NightSlots[this.previousDateSelected['index']].IsSelected = true;
        previousDate = items.Date; 
      }
    }

    /* set data(available slots) in object for selected date. */
    // -------------------------------------------
    this.selectedDayData.morningData = items.MorningSlots;
    this.selectedDayData.afternoonData = items.AfternoonSlots;
    this.selectedDayData.eveningData = items.EveningSlots;
    this.selectedDayData.nightData = items.NightSlots;
    this.monthData = items.Date;
    // -------------------------------------------
    const formData = this.bookAppointmentForm.value;
    formData.bookingDate = "";
    if(previousDate){
      formData.bookingDate = previousDate;
    }
    
    if(formData.bookingDate === items.Date){
      this.slotDataService.setBookAppointment(this.bookAppointmentForm.value);
    }
    else{
      this.slotDataService.setBookAppointment({'bookingDate' : items.Date});
    }
  }

  confirmationData(time,endTime,slot,index,date){
    this.setDataLayer();
    /* Toggle active button selected */
    // -------------------------------------------
    this.selectedDayData.morningData.forEach(data=>{
      if(data.IsSelected){
        data.IsSelected = false;
      }
    });
    this.selectedDayData.afternoonData.forEach(data=>{
      if(data.IsSelected){
        data.IsSelected = false;
      }
    });
    this.selectedDayData.eveningData.forEach(data=>{
      if(data.IsSelected){
        data.IsSelected = false;
      }
    });
    this.selectedDayData.nightData.forEach(data=>{
      if(data.IsSelected){
        data.IsSelected = false;
      }
    });
    
    this.selectedDayData[slot][index].IsSelected = true;
    this.previousDateSelected.slot = slot;
    this.previousDateSelected.index = index;
    this.previousDateSelected.date = date;
    // -------------------------------------------

    this.slotDataService.setDateTime(date, time);
    this.bookAppointmentForm.value["bookingDate"] = date;
    this.bookAppointmentForm.value["bookingTime"] = time;
    this.bookAppointmentForm.value["endTime"] = endTime;
    this.bookAppointmentForm.value[
      "appointmentBookingCode"
    ] = this.slotDataService.getAppointmentCode();
    this.bookAppointmentForm.value["sendMail"] = "true";
    this.bookAppointmentForm.value["isClient"] = "true";
    this.bookAppointmentForm.value[
      "leadUserInfo"
    ] = this.slotDataService.getLeadUserInfo();
    this.bookAppointmentForm.value["timezone"] = this.slotDataService.timezone;
    this.bookAppointmentForm.value["userType"] = this.isRecruiter ? 1 : 2;
    this.slotDataService.setBookAppointment(this.bookAppointmentForm.value);
  }

  setDataLayer(){
    window.parent.postMessage({
      'message': 'success',
      'isSlotSelected' : true
    }, "*");
    // window['dataLayer'] = [];
    //     window['dataLayer'].push({
    //     'Event': 'JobrockEvent',
    //     'jrCategory': 'jr_Event_Slot_Select',
    //     'jrTags': this.appointmentDetail.TagCode ? this.appointmentDetail.TagCode : ''
    //     });
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/slots/choose-slot/choose-slot.component.ts